/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle")?.forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
        this.getAttribute("aria-expanded") === "true"
            ? this.setAttribute("aria-expanded", "false")
            : this.setAttribute("aria-expanded", "true");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
    document.querySelectorAll(".openNav").forEach(el => el.setAttribute("aria-expanded", "true"));
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
    document.querySelectorAll(".openNav").forEach(el => el.setAttribute("aria-expanded", "false"));
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});